import { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';

const API = 'https://affinityconcept.tech/api';

export default function Notes({ token, onLogout }) {
  const [notes, setNotes] = useState([]);
  const [user, setUser] = useState(null);
  const [newNote, setNewNote] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editText, setEditText] = useState('');

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/notes`, { headers }).then(r => setNotes(r.data));
    axios.get(`${API}/me`, { headers }).then(r => setUser(r.data));
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    setLoading(true);
    const res = await axios.post(`${API}/notes`, { content: newNote }, { headers });
    setNotes([res.data, ...notes]);
    setNewNote('');
    setLoading(false);
  };

  const handleEdit = (note) => {
    setEditItem(note.id);
    setEditText(note.content);
  };

  const handleUpdate = async (id) => {
    if (!editText.trim()) return;
    const res = await axios.put(`${API}/notes/${id}`, { content: editText }, { headers });
    setNotes(notes.map(n => n.id === id ? res.data : n));
    setEditItem(null);
    setEditText('');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this note?')) return;
    await axios.delete(`${API}/notes/${id}`, { headers });
    setNotes(notes.filter(n => n.id !== id));
  };

  const filtered = notes.filter(n =>
    n.content.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar onLogout={onLogout} user={user} />
      <main className="flex-1 overflow-y-auto p-4 md:p-8 pt-16 md:pt-8">

        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Notes</h1>
            <p className="text-gray-500 text-sm">{notes.length} notes · add via web or Telegram /note</p>
          </div>
        </div>

        <form onSubmit={handleAdd} className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 mb-6">
          <textarea
            placeholder="Write a note... (or use /note in Telegram)"
            value={newNote}
            onChange={e => setNewNote(e.target.value)}
            rows={3}
            className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 resize-none mb-3"
          />
          <button type="submit" disabled={loading || !newNote.trim()}
            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-xl text-sm font-medium disabled:opacity-50">
            💾 Save Note
          </button>
        </form>

        <div className="relative mb-4">
          <span className="absolute left-3 top-2.5 text-gray-400">🔍</span>
          <input
            placeholder="Search notes..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full bg-white border border-gray-200 rounded-xl pl-9 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          />
          {search && (
            <button onClick={() => setSearch('')}
              className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600">✕</button>
          )}
        </div>

        {search && (
          <p className="text-xs text-gray-400 mb-3">{filtered.length} result{filtered.length !== 1 ? 's' : ''} for "{search}"</p>
        )}

        <div className="space-y-3">
          {filtered.length === 0 && (
            <div className="bg-white rounded-2xl p-12 text-center text-gray-400 text-sm border border-gray-100">
              {search ? `No notes found for "${search}"` : 'No notes yet. Write one above or use /note in Telegram!'}
            </div>
          )}
          {filtered.map(note => (
            <div key={note.id} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 hover:border-green-200 transition">
              {editItem === note.id ? (
                <div>
                  <textarea
                    value={editText}
                    onChange={e => setEditText(e.target.value)}
                    rows={3}
                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 resize-none mb-2"
                    autoFocus
                  />
                  <div className="flex gap-2">
                    <button onClick={() => handleUpdate(note.id)}
                      className="bg-green-600 text-white px-4 py-1.5 rounded-xl text-xs font-medium">
                      Save
                    </button>
                    <button onClick={() => { setEditItem(null); setEditText(''); }}
                      className="border border-gray-200 px-4 py-1.5 rounded-xl text-xs">
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between items-start gap-3">
                  <p className="text-sm text-gray-800 whitespace-pre-wrap flex-1">{note.content}</p>
                  <div className="flex gap-2 flex-shrink-0">
                    <button onClick={() => handleEdit(note)}
                      className="text-gray-400 hover:text-blue-500 transition">✏️</button>
                    <button onClick={() => handleDelete(note.id)}
                      className="text-gray-300 hover:text-red-500 transition">✕</button>
                  </div>
                </div>
              )}
              <p className="text-xs text-gray-400 mt-2">
                {new Date(note.created_at).toLocaleDateString('en-GB', {
                  day: 'numeric', month: 'short', year: 'numeric',
                  hour: '2-digit', minute: '2-digit'
                })}
              </p>
            </div>
          ))}
        </div>

      </main>
    </div>
  );
}
